import { Suspense, lazy } from 'react';
import AuthGuard from './components/AuthGuard';
import DashboardLayout from './views/shared/DashboardLayout';
import GuestGuard from './components/GuestGuard';
// import RoleGuard from './components/RoleGuard';
import LoadingScreen from './components/LoadingScreen';
// import Change from './views/Shared/Change';
import Logout from './views/authentication/Logout';
import ApprovedGuard from './components/ApprovedGuard';
import RoleGuard from './components/RoleGuard';
import ExternalLogin from './views/ExternalLogin';

const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingScreen />}>
    <Component {...props} />
  </Suspense>
);

// Authentication pages

const Login = Loadable(lazy(() => import('./views/authentication/Login')));
const PasswordRecovery = Loadable(lazy(() => import('./views/authentication/PasswordRecovery')));
const PasswordReset = Loadable(lazy(() => import('./views/authentication/PasswordReset')));
const ActivateMyAccount = Loadable(lazy(() => import('./views/authentication/ActivateMyAccount')));
const Register = Loadable(lazy(() => import('./views/authentication/Register')));
const VerifyCode = Loadable(lazy(() => import('./views/authentication/VerifyCode')));
const Dashboard2 = Loadable(lazy(() => import('./components/dashboard/dashboard2/Dashboard2')));
const Account = Loadable(lazy(() => import('./views/Account/Account')));
const InviteSupplier = Loadable(lazy(() => import('./views/InviteSupplier/InviteSupplier')));
const History = Loadable(lazy(() => import('./views/Buyer/Order/MyBidRequestList')));
const OrderHistoryDetails = Loadable(lazy(() => import('./views/Buyer/Order/OrderHistoryDetails')));
const DealDetail = Loadable(lazy(() => import('./views/Seller/Deals/DealDetail')));
const CreateOrder = Loadable(lazy(() => import('./views/Buyer/Order/CreateOrder')));
const Deals = Loadable(lazy(() => import('./views/Seller/Deals/Deals')));
const Chat = Loadable(lazy(() => import('./views/shared/Chat/Chat')));
const BidResponseList = Loadable(lazy(() => import('./views/Seller/Orders/BidResponseList')));
// DUMMY PAGE
// const CustomerDetails = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerDetails')));
// const CustomerEdit = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerEdit')));
// const CustomerList = Loadable(lazy(() => import('./views/Buyer/Dashboard/CustomerList')));
const ServicesContent = Loadable(lazy(() => import('./components/seller/services/ServicesContent')));
// Error pages
const AuthorizationRequired = Loadable(lazy(() => import('./views/AuthorizationRequired')));
const NotFound = Loadable(lazy(() => import('./views/NotFound')));
const ServerError = Loadable(lazy(() => import('./views/ServerError')));
// Notification
const NotificationMain = Loadable(lazy(() => import('./views/shared/NotificationMain')));
const Faq = Loadable(lazy(() => import('./views/shared/Faq')));
const ContactUs = Loadable(lazy(() => import('./views/shared/ContactUs')));
const NeedAprovement = Loadable(lazy(() => import('./views/NeedAprovement')));
const CreatePreDemand = Loadable(lazy(() => import('./views/PreDemand/CreatePreDemand')));
const PreDemands = Loadable(lazy(() => import('./views/PreDemand/PreDemands')));

// Profile

// const SocialProfile = Loadable(lazy(() => import('./views/Buyer/Dashboard/SocialProfile')));

const routes = [
  {
    path: '/login',
    element: (
      <GuestGuard>
        <Login />
      </GuestGuard>
    )
  },
  {
    path: '/password-recovery',
    element: (
      <GuestGuard>
        <PasswordRecovery />
      </GuestGuard>
    )
  },
  {
    path: '/external-login',
    element: (
      <ExternalLogin />
    )
  },
  // {
  //   path: 'customers',
  //   children: [
  //     {
  //       path: '',
  //       element: <CustomerList />
  //     },
  //     {
  //       path: ':customerId',
  //       element: <CustomerDetails />
  //     },
  //     {
  //       path: ':customerId/edit',
  //       element: <CustomerEdit />
  //     }
  //   ]
  // },
  {
    path: '/password-reset',
    children: [
      {
        path: ':token',
        element: (
          <GuestGuard>
            <PasswordReset />
          </GuestGuard>
        )
      },
    ]
  },
  {
    path: '/activatemyaccount',
    children: [
      {
        path: ':token',
        element: (
          <GuestGuard>
            <ActivateMyAccount />
          </GuestGuard>
        )
      },
    ]
  },
  {
    path: '/register',
    element: (
      <GuestGuard>
        <Register />
      </GuestGuard>
    )
  },
  {
    path: '/verify-code',
    element: <VerifyCode />
  },
  {
    path: '/',
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: '',
        element: (<Dashboard2 />)
      },
      {
        path: '/account',
        element: (
          <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
            <Account />
          </RoleGuard>
        )
      },
      {
        path: '/invite-supplier',
        element: (
          <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
            <InviteSupplier />
          </RoleGuard>
        )
      },
      {
        path: '/predemands',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <RoleGuard>
                  <PreDemands />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
          {
            path: '/predemands/create',
            element: (
              <ApprovedGuard>
                <RoleGuard>
                  <CreatePreDemand />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/orders',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <History />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
          {
            path: '/orders/create',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <CreateOrder />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
          {
            path: '/orders/:orderId',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <OrderHistoryDetails />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/bids',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <BidResponseList />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
          {
            path: '/bids/:orderId',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <DealDetail />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
        ]
      },
      {
        path: '/deals',
        children: [
          {
            path: '',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <Deals />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
          {
            path: '/deals/:searchText',
            element: (
              <ApprovedGuard>
                <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                  <Deals />
                </RoleGuard>
              </ApprovedGuard>
            )
          },
        ]
      },
      // {
      //   path: '/deals',
      //   element: (
      //     <Deals />)
      // },
      {
        path: '/chat',
        children: [
          {
            path: '',
            element: (
              <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                <Chat />
              </RoleGuard>
            )
          },
          {
            path: '/chat/:clientId',
            element: (
              <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                <Chat />
              </RoleGuard>
            )
          },
        ]
      },
      {
        path: '/help',
        element: (
          <Faq />
        )
      },
      {
        path: '/contactus',
        element: (
          <ContactUs />
        )
      },
      {
        path: '/needapprovement',
        element: (
          <NeedAprovement />
        )
      },
      {
        path: 'profile',
        children: [
          {
            path: '/profile/:clientId',
            element: (
              <RoleGuard rules={(allRules) => !(allRules.hasCreatePreBidRequest || allRules.hasOnlyStorager)}>
                <ServicesContent />
              </RoleGuard>
            )
          }
        ]
      },
      // {
      //   path: '/dashboard',
      //   element: (
      //     <Overview />
      //   )
      // },
      {
        path: 'notifications',
        element: <NotificationMain />
      },
      {
        path: 'logout',
        element: <Logout />
      },
      {
        path: '401',
        element: <AuthorizationRequired />
      },
      {
        path: '404',
        element: <NotFound />
      },
      {
        path: '500',
        element: <ServerError />
      },
      {
        path: '*',
        element: <NotFound />
      }
    ]
  },
];

export default routes;
